import * as yup from 'yup';

export const validationSchema = yup.object({
    courseName: yup
        .string('Enter valid course name')
        .required('Course Name is required'),
    thumbnail: yup.string('Enter valid file'),
    majorCategory: yup
        .string('Enter valid category')
        .required('Course Category is required'),
    subCategory: yup
        .string('Enter valid category')
        .required('Sub Category is required'),
    description: yup
        .string('Enter valid category')
        .required('Course Description is required')
        .test('maxWords', 'Description must be at most 1500 words', (value) => {
            if (!value) return true;
            const plainText = value
                ? value
                      .replace(/<[^>]*>/g, '')
                      .replace(/&nbsp;/g, ' ')
                      .trim()
                : '';
            const words = plainText
                ? plainText.split(/\s+/).filter(Boolean).length
                : 0;
            return words <= 1500;
        }),
    courseCode: yup
        .string('Enter valid category')
        .required('Course Code is required')
});

export const initialValues = {
    courseName: '',
    thumbnail: '',
    majorCategory: '',
    subCategory: '',
    description: '',
    courseCode: ''
};
